import {DefaultValue, selector, selectorFamily} from 'recoil';

import {
  currentDeviceTypeCodeState,
  currentDeviceTypeState,
  deviceTypesDictQueryByCodeTrigger,
  deviceTypeMapWithNamesState,
  deviceTypesDictQueryTrigger,
  deviceTypesState,
} from './atoms';

import {DictionaryService} from '../../api/services/dictionary.service';

export const deviceTypesDictQuery = selector({
  key: 'deviceTypesDictQuery',
  get: async ({get}) => {
    get(deviceTypesDictQueryTrigger);
    const res = await DictionaryService.getAllDeviceTypes();

    return res.data;
  },

  set: ({set, get}, newValue) => {
    if (newValue) {
      set(deviceTypesState, newValue);

      if (newValue && !(newValue instanceof DefaultValue) && newValue.content?.length > 0) {
        const mapWithNames = get(deviceTypeMapWithNamesState);

        newValue.content.forEach((i) => {
          mapWithNames.set(i.code, i.name);
          mapWithNames.set(i.name?.toLowerCase(), i.code);
        });
      }
    }
  },
});

export const deviceTypesMyDictQuery = selector({
  key: 'deviceTypesMyDictQuery',
  get: async () => {
    const res = await DictionaryService.getMyDeviceTypes();
    return res.data;
  },
});

export const deviceTypeDictQueryByCode = selector({
  key: 'deviceTypeDictQueryByCode',
  get: async ({get}) => {
    const code = get(currentDeviceTypeCodeState);

    if (!code) return null;

    const res = await DictionaryService.getDeviceTypeByCode(String(code));

    return res.data;
  },

  set: ({set}, newValue) => {
    set(currentDeviceTypeState, newValue);
  },
});

export const deviceTypeDictQueryByCodeFamily = selectorFamily({
  key: 'deviceTypeDictQueryByCodeFamily',
  get:
    (code) =>
    async ({get}) => {
      get(deviceTypesDictQueryByCodeTrigger);

      const res = await DictionaryService.getDeviceTypeByCode(String(code));

      return res.data;
    },

  set:
    (code) =>
    ({set}, newValue) => {
      set(currentDeviceTypeState, newValue);
    },
});

export const subTypesSelectorFamily = selectorFamily({
  key: 'subTypesSelectorFamily',
  get:
    (code) =>
    ({get}) => {
      if (!code) return [];

      const {content: types} = get(deviceTypesState);

      return types.filter((i) => i.higherCode === code);
    },
});

export const onlyTypesSelector = selector({
  key: 'onlyTypesSelector',
  get: ({get}) => {
    const {content: types} = get(deviceTypesState);

    return types.filter((i) => !i.higherCode);
  },
});

export const deviceTypeMapWithNamesSelector = selector({
  key: 'deviceTypeMapWithNamesSelector',
  get: ({get}) => {
    const {content: deviceTypes} = get(deviceTypesState);

    const mapWithNames = new Map<string, string>();

    deviceTypes.length > 0 &&
      deviceTypes.forEach((i) => {
        mapWithNames.set(i?.code, i?.name);
      });

    return mapWithNames;
  },
});
